import React from "react";
import {Provider} from "mobx-react";
import {observable} from "mobx";
import SelectionContext from "../contexts/SelectionContext";
import {CollectionContext} from "../collections";
import {getMapValue} from "@morningtrain/react-helpers";

export default class Selection extends React.Component {

    static contextType = CollectionContext;

    @observable selected = new Set();

    get collection() {
        return this.context;
    }

    isSelected(modelKey) {
        return this.selected.has(modelKey + '');
    }

    allSelected() {
        if (this.collection.length < 1) return false;

        return this.collection.every(e => this.isSelected(getMapValue(e, 'id')));
    }

    getSelected = () => {
        return Array.from(this.selected);
    }

    clearSelected = () => {
        this.selected.clear();
    }

    toggleAll(bol) {
        this.collection.forEach(e => this._toggleSelected(getMapValue(e, 'id'), bol));
    }

    toggleSingle(id, bol) {
        this._toggleSelected((id+''), bol);
    }

    _toggleSelected(id, is_selected) {
        is_selected ?
            this.add(id) :
            this.delete(id);
    }

    add(id) {
        this.selected.add(id + '');
    }

    delete(id) {
        return this.selected.delete(id + '');
    }

    render() {
        return (
            <Provider selection={this}>
                <SelectionContext.Provider value={this} >
                    <React.Fragment>
                        {this.props.children}
                    </React.Fragment>
                </SelectionContext.Provider>
            </Provider>
        );
    }

}
